module.exports = __webpack_public_path__ + "static/img/logo.cd4a27eb.png";